import React from 'react'
import './Floorplan.css'
import FloorAreaPanel from './FloorAreaPanel'
import unitData from '../unitData.js'
import { useTranslation } from 'react-i18next'
import i18n from '../i18n';

function Floorplan () {
   const { t } = useTranslation();

   const [open, setOpen] = React.useState(false);

   const [unit, setUnit] = React.useState(1);

   function handleMenu(id) {
      setUnit(id);
      setOpen(false);
   }

   return (
      <div className="floorplan">
         <h1>{t("floorplans-title")}</h1>
         <div>
            <a href='allfloorplans.pdf' download>
            <button className='download-button'> {t("Download All Floorplans")}</button></a>
         </div>
      </div>
   )
}

export default Floorplan